// hero-banner-text-cta.jsx
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {useProducts} from '@salesforce/commerce-sdk-react'
import {safeBuildUrl, getGlobalLink} from '../../../../utils/contentstack-utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const HeroBannerTextCta = ({buttonText, variant, desktopTextAlignment, styles}) => {
    const {buildUrl, locale} = useMultiSite()
    const categoriesData = useGetCategoriesData()

    const hasProductLink = buttonText?.productsfcc?.data?.length > 0

    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: hasProductLink ? buttonText.productsfcc.data[0].id : '',
                expand: ['availability', 'images'],
            },
            headers: {'x-debug': 'hero-banner-index'},
        },
        {enabled: hasProductLink},
    )

    const {url, label, isAbsolute} = getGlobalLink({
        link: buttonText,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })

    if (!label || !url) return null

    const buttonProps = isAbsolute
        ? {as: 'a', href: url, target: '_blank', rel: 'noopener noreferrer'}
        : {as: Link, to: safeBuildUrl(url, buildUrl)}

    return (
        <Box textAlign={{base: 'center', md: 'center', lg: desktopTextAlignment}}>
            <Button
                {...buttonProps}
                data-cs-label="editorial-herobanner-cta"
                variant={variant === 'black' ? 'outline' : 'primary'}
                {...styles.HeroBannerButton}
            >
                {label}
            </Button>
        </Box>
    )
}

HeroBannerTextCta.propTypes = {
    buttonText: PropTypes.shape({
        productsfcc: PropTypes.shape({
            data: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.string,
                }),
            ),
        }),
    }),
    variant: PropTypes.oneOf(['black', 'white']),
    desktopTextAlignment: PropTypes.oneOf(['center', 'left']),
    styles: PropTypes.shape({
        HeroBannerButton: PropTypes.object,
    }),
}
